import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { DeviceItem } from './components/DeviceItem'

type Props = RenderItemProps<'devices'>

export function Item(props: Props) {
  return props.type === 'item' ? <DeviceItem {...props} /> : null
}
